const Navbar = ({ onLogout, userName = "User Name" }) => {
  return (
    <nav className="navbar">
      <div className="navbar-left">
        <div className="logo-section">
          <img src='../../assets/Rockwell-Logo.jpg' alt='rockwell_logo' className="navbar-logo" />
        </div>
      </div>
      
      
      
      <div className="navbar-right">
        <div className="user-info">
          <button className="nav-button" onClick={onLogout}>Logout</button>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;